<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Nombre"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input id="nombre" 
              v-model="filtro.nombre" 
              type="text"></b-form-input>
          </b-form-group>

          <app-paises
            label="Pais"
            labelOption="Todos los paises"
            :horizontal="Boolean(true)"
            :nullDisabled="Boolean(false)"
            :labelCols="labelCols"
            :nombre="paisNombre"
            :lista="paisesList"
            @updated="paisActualizado">
          </app-paises>

          <app-provincias
            label="Provincia"
            labelOption="Todas las provincias"
            :horizontal="Boolean(true)"
            :nullDisabled="Boolean(false)"
            :labelCols="labelCols"
            :nombre="provinciaNombre"
            :lista="provinciasList"
            @updated="provinciaActualizada">
          </app-provincias>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="filtrar">Filtrar</b-button>
            <b-button size="sm" variant="primary" class="footer-button" 
              @click.prevent="limpiarFiltro">Limpiar</b-button>
          </div>
        </b-form>
      </b-collapse>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Paises from '../shared/abmSelect.vue';
import Provincias from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';

export default {
  name: 'LocalidadesListFiltro',
  components: {
    appPaises: Paises,
    appProvincias: Provincias,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  props: {
    nombre: {
      type: String,
      default: ''
    },
    pais: {
      type: Object,
      default: null
    },
    provincia: {
      type: Object,
      default: null
    },
  },
  data: () => {
    return {
      filtro: {
        nombre: '',
        pais: null,
        provincia: null
      },

      paises: [],
      paisesList: [],
      provincias: [],
      provinciasList: [],
      showOpcionesFiltro: false,
      labelCols: 2,
      loadingPaises: false,
      loadingProvincias: false,
    }
  },
  computed: {
    paisNombre() {
      if (this.filtro) {
        if (this.filtro.pais) {
          if (this.filtro.pais.nombre) {
            return this.filtro.pais.nombre.trim();
          }
        }
      }

      return null;
    },
    provinciaNombre() {
      if (this.filtro) {
        if (this.filtro.provincia) {
          if (this.filtro.provincia.nombre) {
            return this.filtro.provincia.nombre.trim();
          }
        }
      }

      return null;
    }
  },
  created() {
    this.filtro.nombre = this.nombre;
    this.filtro.pais = this.pais;
    this.filtro.provincia = this.provincia;

    this.getDatosAdicionales();
  },  
  methods: {
    getDatosAdicionales() {
      this.loadingPaises = true;
      this.loadingProvincias = true;

      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          this.paises = this.$store.getters['paises/paisesSelect'];
          this.paisesList = this.$store.getters['paises/listSelect'];
          this.loadingPaises = false;
          return;
        })
        .then (() => this.getProvincias())
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de paises.'));
    },
    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.filtro.pais) {
        if (this.filtro.pais.id) {
          this.$store.dispatch('provincias/getList', this.filtro.pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro () {
      this.filtro.nombre = '';
      this.filtro.pais = null;
      this.filtro.provincia = null;
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.filtro.pais = this.getSelected(this.paises, paisNombre);

        this.filtro.provincia = null;
        this.getProvincias();
      }
    },
    provinciaActualizada(provinciaNombre) {
      if (!this.loadingProvincias) {
        this.filtro.provincia = this.getSelected(this.provincias, provinciaNombre);
      }
    },
  },
}
</script>

<style>
</style>
